import axios from 'axios';

export const validateRecaptchaToken = async (token) => {
  try {
    const response = await axios.get(`https://api.modernizacion.gob.sv/api/verify?token=${token}`);
    //const response = await axios.get(`/api/verify?token=${token}`);

    if (response.status === 200) {
      return response.data;
    } else {
      const error = response.data;
      console.error(`Error validating reCAPTCHA token: ${error}`);
      return { success: false, error };
    }
  } catch (error) {
    console.error(error);
    return { success: false, error: 'Network error' };
  }
};
